// Cámara compartida: al cerrarla queda lista 1 minuto (la próxima foto abre al instante) y después se apaga sola.
// Si la cámara trasera por defecto no tiene linterna, se busca la que sí y se recuerda en el equipo.
const ESPERA_MS = 60000;
const CLAVE_FLASH = 'camara_con_flash';
const c = { stream: null, frente: null, pedido: null, timer: null };

const viva = () => !!c.stream?.getVideoTracks().some((t) => t.readyState === 'live');
const video = (extra) => ({ audio: false, video: { ...extra, width: { ideal: 1920 }, height: { ideal: 1080 } } });
const guardada = () => { try { return localStorage.getItem(CLAVE_FLASH); } catch { return null; } };

export const soltarCamara = () => {
  clearTimeout(c.timer);
  c.stream?.getTracks().forEach((t) => t.stop());
  c.stream = null;
  c.frente = null;
  c.pedido = null;
};

const abrir = (frente) => {
  const id = !frente && guardada();
  const normal = () => navigator.mediaDevices.getUserMedia(video({ facingMode: { ideal: frente ? 'user' : 'environment' } }));
  if (!id) return normal();
  return navigator.mediaDevices.getUserMedia(video({ deviceId: { exact: id } })).catch(() => { localStorage.removeItem(CLAVE_FLASH); return normal(); });
};

export const pedirCamara = (frente) => {
  clearTimeout(c.timer);
  if (c.frente === frente && c.pedido) return c.pedido;
  if (c.frente === frente && viva()) return Promise.resolve(c.stream);
  soltarCamara();
  c.frente = frente;
  c.pedido = abrir(frente).then((s) => {
    c.stream = s;
    c.pedido = null;
    return s;
  }).catch((e) => {
    c.pedido = null;
    c.frente = null;
    throw e;
  });
  return c.pedido;
};

// Prueba las otras cámaras traseras hasta encontrar una con linterna (true si la encontró y quedó abierta)
export const buscarCamaraConFlash = async () => {
  const actual = c.stream?.getVideoTracks()[0]?.getSettings?.().deviceId;
  const lista = (await navigator.mediaDevices.enumerateDevices())
    .filter((d) => d.kind === 'videoinput' && d.deviceId && d.deviceId !== actual && !/front|frontal|user|delantera|selfie|facetime/i.test(d.label));
  soltarCamara(); // muchos celulares no abren dos cámaras a la vez
  for (const d of lista) {
    try {
      const s = await navigator.mediaDevices.getUserMedia(video({ deviceId: { exact: d.deviceId } }));
      if (s.getVideoTracks()[0]?.getCapabilities?.()?.torch) {
        localStorage.setItem(CLAVE_FLASH, d.deviceId);
        c.stream = s;
        c.frente = false;
        return true;
      }
      s.getTracks().forEach((t) => t.stop());
    } catch { /* sigue con la próxima */ }
  }
  return false;
};

// Al cerrar: se apaga la linterna y el stream espera 1 minuto por si viene otra foto
export const dejarCamaraLista = () => {
  const t = c.stream?.getVideoTracks()[0];
  if (t?.getCapabilities?.()?.torch) t.applyConstraints({ advanced: [{ torch: false }] }).catch(() => {});
  clearTimeout(c.timer);
  c.timer = setTimeout(soltarCamara, ESPERA_MS);
};

// Si la app pasa a segundo plano con la cámara cerrada, se apaga en el acto
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && !document.querySelector('[data-camara-en-vivo]')) soltarCamara();
  });
}
